import React, { useState } from 'react';
import {
  checkAdminPassword,
  fetchSiteStatus,
  saveSiteStatus,
} from '../services/siteStatusService';
import './AdminPage.css';

// Hidden page (/admin) for switching the "we're away" banner on and off.
const AdminPage = () => {
  const [password, setPassword] = useState('');
  const [unlocked, setUnlocked] = useState(false);
  const [away, setAway] = useState(false);
  const [backOn, setBackOn] = useState('');
  const [message, setMessage] = useState('');
  const [feedback, setFeedback] = useState('');
  const [busy, setBusy] = useState(false);

  const unlock = async (e) => {
    e.preventDefault();
    setBusy(true);
    setFeedback('');
    try {
      if (!(await checkAdminPassword(password))) {
        setFeedback('Wrong password');
        return;
      }
      const status = await fetchSiteStatus();
      setAway(status.away);
      setBackOn(status.backOn);
      setMessage(status.message);
      setUnlocked(true);
    } catch {
      setFeedback('Could not reach the server');
    } finally {
      setBusy(false);
    }
  };

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setFeedback('');
    try {
      await saveSiteStatus(password, { away, backOn, message });
      setFeedback('Saved ✓ — the site updates within a minute');
    } catch {
      setFeedback('Could not save, please try again');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-card">
        <h1>{unlocked ? 'Shop status' : 'Admin'}</h1>

        {!unlocked ? (
          <form onSubmit={unlock}>
            <label>
              Password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
            </label>
            <button type="submit" disabled={busy || !password}>Continue</button>
          </form>
        ) : (
          <form onSubmit={save}>
            <button
              type="button"
              role="switch"
              aria-checked={away}
              className={`admin-switch ${away ? 'is-away' : 'is-open'}`}
              onClick={() => setAway(!away)}
            >
              <span className="admin-switch-label">{away ? "We're away" : "We're open"}</span>
              <span className="admin-switch-track"><span className="admin-switch-thumb" /></span>
            </button>

            {away && (
              <>
                <label>
                  Back on
                  <input type="date" value={backOn} onChange={(e) => setBackOn(e.target.value)} />
                </label>
                <label>
                  Message
                  <input
                    type="text"
                    maxLength={300}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Leave empty for the default message"
                  />
                </label>
              </>
            )}

            <button type="submit" className="admin-save" disabled={busy}>Save</button>
          </form>
        )}

        {feedback && <p className="admin-feedback">{feedback}</p>}
      </div>
    </div>
  );
};

export default AdminPage;
